import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initKuaishouQuery } from './utils/kuaishouQuery'

import 'swiper/css/swiper.min.css'

Vue.config.productionTip = false

// 初始化快手渠道 query 共享（跨子域名）
initKuaishouQuery()

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
